import React from 'react';
import { connect } from 'react-redux';
import { Dialog, TextField, IconButton, RaisedButton, Checkbox } from 'material-ui';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import BoxInEditMode from '../create-group/step-two-templates';
import debounce from 'lodash.debounce';
import { editTemplateGroup } from '../../../../stores/contracting/template-list/template-list-actions';
import R from 'ramda';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const EditGroupDialog = ({ editDialogOpen, editGroupName, editGroup, editGroupError, editGroupId, selectedTemplatesForGroup, groupWizardTemplates, updateProps, proceedEditing }) => {
  const closeDialog = () => updateProps({
    editGroupName: '',
    editGroupId: '',
    editGroupStartDate: '',
    editGroupEndDate: '',
    selectedTemplatesForGroup: [],
    editDialogOpen: false,
    editGroupError: '',
    updatingGroup: false,
    groupUpdated: false,
    proceedEditing: false,
    groupWizardTemplates: [],
  });
  return (
    <Dialog
      open={editDialogOpen}
      autoScrollBodyContent
      onRequestClose={closeDialog}
      titleStyle={{ padding: '8px 16px' }}
      actions={[
        <div key="error" style={{ color: 'red' }}>
          {editGroupError}
        </div>,
        <FlatButton
          key="cancel"
          label="Cancel"
          onTouchTap={closeDialog}
        />,
        proceedEditing ? (<FlatButton
          key="save"
          secondary
          label="Save"
          onTouchTap={() => {
            if (!editGroupName) {
              updateProps({ editGroupError: 'Group Name cannot be empty.' });
              debounce(() => updateProps({ editGroupError: '' }), 4000)();
            } else if (isNilOrEmpty(selectedTemplatesForGroup)) {
              updateProps({ editGroupError: 'Please include at least one template in this group.' });
              debounce(() => updateProps({ editGroupError: '' }), 4000)();
            }
            else editGroup({ groupId: editGroupId, newGroupName: editGroupName, templates: selectedTemplatesForGroup });
          }}
        />) : (<RaisedButton
          key="save"
          secondary
          labelStyle={{ textTransform: 'none' }}
          label="Okay, Edit Group"
          onTouchTap={() => updateProps({ proceedEditing: true })}
        />),
      ]}
      title={
        proceedEditing ? (<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            Edit&nbsp;<i>{`${editGroupName}`}</i>
          </div>
          <IconButton
            iconClassName="tc-icon-close"
            iconStyle={{ color: 'red', fontSize: '32px' }}
            onTouchTap={closeDialog}
          />
        </div>) : 'Please read this message before you continue'
      }
    >
      {
        proceedEditing ? (
          <div>
            <TextField
              floatingLabelText="Group Name"
              value={editGroupName}
              onChange={(_, val) => updateProps({ editGroupName: val })}
            />
            <BoxInEditMode
              templates={groupWizardTemplates}
              updateProps={updateProps}
              selectedTemplatesForGroup={selectedTemplatesForGroup}
            />
          </div>
        ) : (
          <div style={{ padding: '32px' }}>
            We allow you to edit your template group name, and add or remove templates within that group. This will only affect any future contracts that you send, and it will not affect any contracts that you have already issued. If you need to send a new template to your partners, you can do that individually.
          </div>
        )
      }
    </Dialog>
  );
};

const mapStateToProps = ({ contracting, user }) => ({
  editGroupName: contracting.templateList.get('editGroupName'),
  editGroupError: contracting.templateList.get('editGroupError'),
  editGroupId: contracting.templateList.get('editGroupId'),
  selectedTemplatesForGroup: contracting.templateList.get('selectedTemplatesForGroup').toJS(),
  groupWizardTemplates: contracting.templateList.get('groupWizardTemplates').toJS(),
  editDialogOpen: contracting.templateList.get('editDialogOpen'),
  proceedEditing: contracting.templateList.get('proceedEditing'),
});
const mapDispatchToProps = dispatch => ({
  editGroup: (...args) => dispatch(editTemplateGroup(...args)),
});
export default connect(mapStateToProps, mapDispatchToProps)(EditGroupDialog);



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/list/edit-group-dialog.jsx